import { render, staticRenderFns } from "./tasklist.vue?vue&type=template&id=37e605a4&scoped=true"
import script from "./tasklist.vue?vue&type=script&lang=js"
export * from "./tasklist.vue?vue&type=script&lang=js"
import style0 from "./tasklist.vue?vue&type=style&index=0&id=37e605a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e605a4",
  null
  
)

export default component.exports